export const MATCH_TIERS = {
  EXCELLENT: 'Excellent',
  STRONG: 'Strong',
  GOOD: 'Good',
}
